export function copyLink() {
    document.addEventListener('click', function (e) {
    const btn = e.target.closest('.farlo-share-widget__copy-link');
    if (!btn) return;

    const original = btn.querySelector('span');
    const copiedText = btn.getAttribute('data-copied-text') || 'Copied';
    const copyText   = btn.getAttribute('data-copy-text')   || 'Copy Link';

    navigator.clipboard.writeText(window.location.href).then(function () {
      if (original) {
        original.textContent = copiedText;
        original.classList.remove('mobile-hidden');
        setTimeout(function () {
          original.textContent = copyText;
          original.classList.add('mobile-hidden');
        }, 2000);
      }
    }).catch(function () {
      alert(copiedText);
    });
  });
}